export const COMPETITION_LEVELS_BY_CATEGORY = {
  Seniors: [
    'NATIONAL', 'NATIONAL 1', 'NATIONAL 2',
    'RÉGIONAL 1', 'RÉGIONAL 2', 'RÉGIONAL 3',
    'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3',
  ],
  U19: [
    'U19 NATIONAL',
    'RÉGIONAL 1', 'RÉGIONAL 2', 'RÉGIONAL 3', 'TERRITOIRE',
    'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3',
  ],
  U17: [
    'U17 NATIONAL',
    'RÉGIONAL 1', 'RÉGIONAL 2', 'RÉGIONAL 3', 'TERRITOIRE',
    'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3',
  ],
  U14: ['RÉGIONAL 1', 'RÉGIONAL 2', 'TERRITOIRE', 'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3'],
  U15: ['RÉGIONAL 1', 'RÉGIONAL 2', 'TERRITOIRE', 'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3'],
  U16: ['RÉGIONAL 1', 'RÉGIONAL 2', 'TERRITOIRE', 'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3'],
  U18: ['RÉGIONAL 1', 'RÉGIONAL 2', 'TERRITOIRE', 'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3'],
}

export const ALL_COMPETITION_LEVELS = [
  'NATIONAL', 'NATIONAL 1', 'NATIONAL 2',
  'RÉGIONAL 1', 'RÉGIONAL 2', 'RÉGIONAL 3',
  'TERRITOIRE',
  'DÉPARTEMENTAL 1', 'DÉPARTEMENTAL 2', 'DÉPARTEMENTAL 3',
  'U19 NATIONAL', 'U17 NATIONAL',
]
